import {ofType} from 'redux-observable';
import {of} from 'rxjs';
import {mergeMap, map, catchError, flatMap} from 'rxjs/operators';
import {destroy, change} from 'redux-form';

import {combineEpics} from 'web-app/util/redux-observable';
import {LISTS_LIMITATION_EXCEEDED} from 'web-app/util/error-codes';
import {track} from 'web-app/util/famlytics';
import {TrackingEvents} from 'web-app/util/famlytics/events';

import * as API from './api';
import * as Actions from './actions';
import * as Constants from './constants';

const fetchDescription = action$ =>
    action$.pipe(
        ofType(Actions.fetchDescription.type),
        mergeMap(({payload}: ReturnType<typeof Actions.fetchDescription.action>) =>
            API.describe(payload.institutionId, payload.filtersAndColumnsKind).pipe(
                map(response => Actions.fetchDescriptionSuccess.action(response)),
                catchError(e => of(Actions.fetchDescriptionFailed.action(e))),
            ),
        ),
    );

const destroyFormsOnChange = action$ =>
    action$.pipe(
        ofType(Actions.changeFiltersAndColumnsKind.type),
        map(() => destroy(Constants.COLUMNS_FORM, Constants.FILTERS_FORM)),
    );

const clearFiltersOnHide = action$ =>
    action$.pipe(
        ofType(Actions.hideFilterSection.type),
        flatMap(({payload}: ReturnType<typeof Actions.hideFilterSection.action>) => {
            return payload.filterEntityIds.map(filterEntityId => change(Constants.FILTERS_FORM, filterEntityId, null));
        }),
    );

const createList = action$ =>
    action$.pipe(
        ofType(Actions.createList.type),
        flatMap(({payload}: ReturnType<typeof Actions.createList.action>) =>
            API.createList(payload.institutionId, payload.name, payload.filter, payload.kind).pipe(
                map(response => Actions.createListSuccess.action(response)),
                catchError(e => {
                    if (e.errorCode === LISTS_LIMITATION_EXCEEDED) {
                        track(TrackingEvents.LISTS_LIMITED_FEATURE, {
                            message: e.error,
                        });
                    }
                    return of(Actions.createListFailed.action(e));
                }),
            ),
        ),
    );

const updateList = action$ =>
    action$.pipe(
        ofType(Actions.updateList.type),
        flatMap(({payload}: ReturnType<typeof Actions.updateList.action>) =>
            API.updateList(payload.presetId, payload.name, payload.filter).pipe(
                map(response => Actions.updateListSuccess.action(response)),
                catchError(e => of(Actions.updateListFailed.action(e))),
            ),
        ),
    );

export default combineEpics(fetchDescription, destroyFormsOnChange, clearFiltersOnHide, createList, updateList);
